import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.JobSearchRoot),
  () => import('./JobSearch'),
  (JobSearch) => {
    ComponentUtil.binder(Hooks.JobSearchRoot, JobSearch);
  },
);
